import { AdReviewV5, AdStatusV5, Asset2ReviewStatus, Review } from '../apis/graphql';
import type { AdsPageAd } from '../common/AdForm/hooks/types';
import {
  CREATIVE_TYPES_THAT_DO_NOT_NEED_TO_BE_APPROVED,
  RESTRICTED_CREATIVE_TYPES,
} from '../common/constants/creative';
import { OMS_LINK_TYPES_DO_NOT_NEED_TO_BE_VERIFIED } from '../common/constants/lineItem';
import type { Nullable } from '../models';
import type { AdModel } from '../pages/Trafficking/TraffickingPage/modelConverters';
import type { AdEntity } from '../pages/Trafficking/TraffickingPageDrawer/MultipleEditDrawer/types';

type IsAdSwitchToOnForbiddenProps = {
  ad: AdEntity;
  creativeReview?: Nullable<Asset2ReviewStatus>;
};

export const isSwitchToOnForbidden = (ad: AdModel | AdsPageAd): boolean => {
  if (!ad.creative) return false;

  return (
    ad.review.key === AdReviewV5.Approved &&
    ad.status.key !== AdStatusV5.On &&
    ad.creative.review === Review.Rejected &&
    RESTRICTED_CREATIVE_TYPES.includes(ad.creative.type)
  );
};

export const isAdActivationForbidden = ({ ad, creativeReview }: IsAdSwitchToOnForbiddenProps): boolean => {
  if (!ad.creative) return true;

  // Allow switching on if creative type is in the allowed list (MAGNITE, PAUSE, DRAX)
  // or if the line item uses DCM order lineOmsLink type
  if (
    CREATIVE_TYPES_THAT_DO_NOT_NEED_TO_BE_APPROVED.includes(ad.creative.type) ||
    (ad?.lineItem?.lineOmsLink?.type &&
      OMS_LINK_TYPES_DO_NOT_NEED_TO_BE_VERIFIED.includes(ad.lineItem.lineOmsLink.type))
  ) {
    return false;
  }

  // Forbid switching on if the creative review status is not accepted
  if (creativeReview !== Asset2ReviewStatus.Accepted) {
    return true;
  }

  return false;
};
